import React from 'react';

import { Table, Tbody, Thead, Tr } from '@lightspeed/cirrus-table';
import { Checkbox } from '@lightspeed/flame/Checkbox';
import { Box } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { Tooltip } from '@lightspeed/flame/Tooltip';

import Format from 'root/apps/helpers/format';

import {
  MatrixListingCheckTH,
  MatrixListingTD,
  MatrixListingTH,
  NO_IMAGE_URL,
} from '../B2BItemsListing.styles';
import { findMSRP } from '../utils';
import B2BMatrixContext from './B2BMatrixContext';

const B2BMatrixListing = () => {
  const context = React.useContext(B2BMatrixContext);
  const allSelected = context.items.every((item) => item.selected);
  const indeterminate = !allSelected && context.items.some((item) => item.selected);

  return (
    <Box m="-1.5rem">
      <Box pt={4} pb={3} pl={4} style={{ borderBottom: 'solid 1px #d7dce1' }}>
        <Text fontSize="14px" lineHeight="18px" color="#000">
          Select the variants you wish to import with this item.
        </Text>
      </Box>
      <Table>
        <Thead>
          <Tr>
            <MatrixListingCheckTH pl="30px">
              <Checkbox
                id="select-all-items"
                data-test="select-all-items"
                name="matrix-items"
                checked={allSelected}
                indeterminate={indeterminate}
                onChange={() => {
                  if (allSelected) context.selectNoneItems();
                  else context.selectAllItems();
                }}
              />
            </MatrixListingCheckTH>
            <MatrixListingTH width="70px">Image</MatrixListingTH>
            <MatrixListingTH>Item Description</MatrixListingTH>
            <MatrixListingTH>UPC</MatrixListingTH>
            <MatrixListingTH>MSRP</MatrixListingTH>
            <MatrixListingTH>Brand</MatrixListingTH>
            <MatrixListingTH>Color</MatrixListingTH>
            <MatrixListingTH>Size</MatrixListingTH>
            <MatrixListingTH>Season</MatrixListingTH>
          </Tr>
        </Thead>
        <Tbody>
          {context.items.map((item, index) => {
            const b2bItem = item.b2bItem;
            const b2bMsrp = findMSRP(b2bItem);
            const b2bMsrpLabel = b2bMsrp ? Format.toMoney(b2bMsrp.amount, b2bMsrp.currency) : 'N/A';
            item.index = index;

            return (
              <Tr key={`b2bmatrixitem_${b2bItem.id}`}>
                <MatrixListingCheckTH>
                  {item.previouslyImported ? (
                    <Tooltip content="Imported item" placement="right">
                      <Checkbox
                        id={b2bItem.id}
                        data-test={`checkbox-${index}`}
                        checked={true}
                        disabled={true}
                      />
                    </Tooltip>
                  ) : (
                    <Checkbox
                      id={b2bItem.id}
                      data-test={`checkbox-${index}`}
                      checked={item.selected}
                      onChange={() => context.toggleItemSelect(index)}
                    />
                  )}
                </MatrixListingCheckTH>
                <MatrixListingTD>
                  <img
                    src={b2bItem.images?.[0]?.image_url || NO_IMAGE_URL}
                    alt={`${b2bItem.color} ${b2bItem.size} ${b2bItem.brand_name} ${b2bItem.name}`}
                  />
                </MatrixListingTD>
                <MatrixListingTD>
                  <var>{b2bItem.name}</var>
                </MatrixListingTD>
                <MatrixListingTD>
                  <var>{b2bItem.upc}</var>
                </MatrixListingTD>
                <MatrixListingTD>
                  <var>{b2bMsrpLabel}</var>
                </MatrixListingTD>
                <MatrixListingTD>
                  <var>{b2bItem.brand_name}</var>
                </MatrixListingTD>
                <MatrixListingTD>
                  <var>{b2bItem.color}</var>
                </MatrixListingTD>
                <MatrixListingTD>
                  <var>{b2bItem.size}</var>
                </MatrixListingTD>
                <MatrixListingTD>
                  <var>{b2bItem.season}</var>
                </MatrixListingTD>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
};

export default B2BMatrixListing;
